module.exports = __webpack_public_path__ + "static/asd-4bb7ea6f8a0008363ae7d9cfce9e7a31.png";